// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4579a7ee","455":"a6e7f212","977":"e64e12f9"}[chunkId] + ".chunk.js";
};